
$('document').ready(function(){

  $('.header-custom-wrapper .menu-toggle').click(function(){
    $('.header-custom-wrapper .mobile-header .menues-wrapper').addClass('active');
    $(this).addClass('active');
    $('body').addClass('open')
  });
  $('.header-custom-wrapper .menu-close-btn').click(function(){
    $('.header-custom-wrapper .mobile-header .menues-wrapper').removeClass('active');
    $(this).removeClass('active');
    $('body').removeClass('open')
  });
  $('.header-custom-wrapper .mobile-header .menu-toggle-icon').click(function(e){
    e.preventDefault();
    $(this).toggleClass('active');
    $(this).parents('.menu-item').find('.mega-menu-wrapper').slideToggle();
  })

   $('.header-custom-wrapper .header-search-btn').click(function(e){
    e.preventDefault();
    $(this).parents('.search-box-wrapper').find('.header-search-box').addClass('active');
  })
   $('.header-custom-wrapper .search-box-wrapper .btn-close').click(function(e){
    e.preventDefault();
    $(this).parents('.search-box-wrapper').find('.header-search-box').removeClass('active');
  })

  $('.accor-head').click(function(){
    $(this).toggleClass('active').parents('.accor-row').find('.accor-content').slideToggle();
  })

   // /*---------------tab component -----------*/
    $('.tab-btn-wrapper .tab-link a').click(function(e){
        e.preventDefault();
        let tabId = $(this).attr('href');
        $(this).parents('.tab-link').addClass('active').siblings('.tab-link').removeClass('active');
        $(this).parents('.tab-wrapper').find('.tab-content').removeClass('active');
        $(tabId).addClass('active');
    })
    $('.tab-btn-wrapper .tab-link:first-of-type a').click();

  var swiper = new Swiper(".featured-product-slider .swiper", {
      slidesPerView: 1,
      speed: 1000,
      loop: true,
      parallax: true,
      navigation: {
        nextEl: ".featured-product-slider .swiper-button-next",
        prevEl: ".featured-product-slider .swiper-button-prev",
      },
    });


   var swiper = new Swiper(".furniture-slider .swiper", {
      slidesPerView: 4,
      loop: true,
      speed: 1000,
      parallax: true,
      spaceBetween: 18,
      navigation: {
        nextEl: ".furniture-slider .swiper-button-next",
        prevEl: ".furniture-slider .swiper-button-prev",
      },
       breakpoints: {
          0: {
              slidesPerView: 1,
              spaceBetween: 15,
          },
          576: {
              slidesPerView: 2,
              spaceBetween: 15,
          },
          768: {
              slidesPerView: 3,
              spaceBetween: 15,
          },
          993: {
              slidesPerView: 4,
              spaceBetween: 18,
          }
      }
    });


     var swiper = new Swiper(".furniture-slider-tabs .swiper", {
      slidesPerView: 4,
      loop: true,
      speed: 500,
      // parallax: true,
      spaceBetween: 18,
      navigation: {
        nextEl: ".furniture-slider-tabs .swiper-button-next",
        prevEl: ".furniture-slider-tabs .swiper-button-prev",
      },
       breakpoints: {
          0: {
              slidesPerView: 1,
              spaceBetween: 15,
          },
          576: {
              slidesPerView: 2,
              spaceBetween: 15,
          },
          768: {
              slidesPerView: 3,
              spaceBetween: 15,
          },
          993: {
              slidesPerView: 4,
              spaceBetween: 18,
          }
      }
    });

   var swiper = new Swiper(".review-slider .swiper", {
      slidesPerView: 1,
      loop: true,
      speed: 1000,
      parallax: true,
      spaceBetween: 18,
      navigation: {
        nextEl: ".review-slider .swiper-button-next",
        prevEl: ".review-slider .swiper-button-prev",
      },
    });


    var swiper = new Swiper(".history-slider .swiper", {
      slidesPerView: 1,
      // loop: true,
      speed: 1000,
      parallax: true,
      spaceBetween: 110,
      navigation: {
        nextEl: ".history-slider .swiper-button-next",
        prevEl: ".history-slider .swiper-button-prev",
      },
      breakpoints: {
          0: {
              spaceBetween: 20,
          },
          576: {
              spaceBetween: 20,
          },
          768: {
              spaceBetween: 40,
          },
          993: {
              spaceBetween: 70,
          },
          1281: {
            spaceBetween: 110,
          }
      }
    });

   var swiper = new Swiper(".home-decor-slider .swiper", {
      slidesPerView: 5,
      // loop: true,
      speed: 1000,
      parallax: true,
      spaceBetween: 12,
      navigation: {
        nextEl: ".home-decor-slider .swiper-button-next",
        prevEl: ".home-decor-slider .swiper-button-prev",
      },
      breakpoints: {
          0: {
              slidesPerView: 1.5,
          },
          481: {
              slidesPerView: 2,
          },
          768: {
              slidesPerView: 3,
          },
          993: {
              slidesPerView: 4,
          },
          1281: {
            spaceBetween: 12,
            slidesPerView: 5,
          }
      }
    });

     $(".scrollToSec a").click(function (e) {
      e.preventDefault();
      var id = jQuery(this).attr("href");
     // console.log('clicked...')
      $("html, body").animate({
          scrollTop: $(id).offset().top - ($('.header-custom-wrapper').innerHeight())*1.25,
        },
        1000
      );
    });
  
})


var headerHeight= $('.header-custom-wrapper').innerHeight();
jQuery(window).on("load scroll", function () {
  // var headerHeight= $('.site-header').outerHeight();
  console.log(headerHeight);
  var scrollTop = $(window).scrollTop();
  if(scrollTop > 0) {
      $('.header-custom-wrapper').addClass('sticky');
      //$('body').css('padding-top', headerHeight);
  }else {
      $('.header-custom-wrapper').removeClass('sticky');
      //$('body').css('padding-top', 0);
  }

})
/* window load & scroll ends */


$(window).on('load resize', function(){
    var widthfull = $('.container-full').width();
    var containerWidth = $('.container').width();
    if(widthfull > containerWidth){
        var padding = (widthfull - containerWidth)/2;
        $('.padding-right').css('padding-right',padding);
        $('.padding-left').css('padding-left',padding);
    }

    var windowHeight = $(window).height();
    var innerTopbar = $('.variant__description_drawer .heading-wrapper').innerHeight();
    var boxHeight = windowHeight - innerTopbar;
    $('.product__info-wrapper').each(function () {
    $(this).get(0).style.setProperty('--boxHeight', boxHeight + 'px');
});
    // $('.variant__description_drawer .swatch-drawer-wrapper').css("--boxHeight", boxHeight + "px");
    console.log("xxxxx", boxHeight);
})


if ($(window).width() > 767)
  {
      $('body').on('click','.custom-dot-buttons', function() {
        var dot_index= $(this).attr("data-index");
        // alert(dot_index);
       $( ".thumbnail-list__item" ).each(function() {
           if($(this).hasClass(dot_index)){
             // alert("found");
             $(this).children(".thumbnail").trigger("click");
           }        
       });        
      });
     $('body').on('click','.thumbnail-list__item', function() {
       var thumb_image_number = $(this).attr("data-thumb-index");
       // alert(thumb_image_number);
       $(".custom-dot-buttons").removeClass("slider-counter__link--active"); 
       $( ".custom-dot-buttons" ).each(function() {
         var dot_index_number = $(this).attr("data-index");
         // alert(dot_index_number);
           if(thumb_image_number == dot_index_number){
             // alert("found");
             $(this).addClass("slider-counter__link--active");
           }         
       });
     });  
    
  }  


//Main swatch drawer JS
$(document).ready(function(){
  // Hide the select box
  $('.changeRadio').hide();

// Array to store unique values
var uniqueValues = [];

$(".imageVariant img").each(function() {
    var imgUrl = $(this).data('img-src'); // Retrieve image URL
    var imgValue = $(this).attr('value'); // Retrieve image value
    imagValueWoodSpecies = imgValue.trim(); // Trim the retrieved value

    // Find the index of '/'
    var index = imagValueWoodSpecies.indexOf('/');

    // Check if '/' is found
    if (index !== -1) {
        // Remove everything after '/'
        imgValueSingleOption = imagValueWoodSpecies.substring(0, index).trim();
    } else {
        // If '/' is not found, keep the original string
        imgValueSingleOption = imagValueWoodSpecies;
    }

    // Check if the value is already in the uniqueValues array
    if (!uniqueValues.includes(imgValueSingleOption)) {
        // Add the value to the array if it's not already there
        uniqueValues.push(imgValueSingleOption);

        // Output the result
        console.log(imgValueSingleOption);

        // Create radio button based on select options
        var $radioButton = $('<input type="radio" class="radio-image-input" name="options" value="' + imgValueSingleOption + '">');
        var $radioLabel = $('<div class="image-btn-wrapper"><div class="image-title">' +
            '<a href="#"><label class="radio-image-label">' +
            '<img src="' + imgUrl + '" height="50" width="50">' +
            $radioButton[0].outerHTML +
            '<span class="btn_choose">' + imgValueSingleOption + '</span></label></a></div></div>');

        // Append radio button to the container
        $('#radioButtons').append($radioLabel);
    }
});



  
  // Handle changes in radio buttons
  $('#radioButtons').on('change', 'input[type="radio"]', function() {
    var selectedValue = $(this).val();
    //console.log(selectedValue);
    $('.changeRadio').val(selectedValue).change(); // Trigger change event manually
  });


  //for poly colors

  function getVariantIdFromUrlPoly() {
    var url = window.location.href;
    var regex = /variant=([0-9]+)/;
    var match = regex.exec(url);
    if (match && match[1]) { 
        return match[1]; 
    }
    return null;
}

  
  // Hide the select box
  $('.polycolor').hide();

  // Iterate over each image element and create radio buttons
  $(".imageVariant-PolyColor img").each(function() {
    var imgUrlPoly = $(this).data('img-src'); // Retrieve image URL
    var imgValuePoly = $(this).attr('value'); // Retrieve image value
    var polyVariantId = $(this).attr("data-var-id");
    // Create radio button based on select options
    var $radioButtonPoly = $('<input type="radio" data-variant-id="' + polyVariantId + '" class="radio-image-input-poly" name="options" value="' + imgValuePoly + '">');
    var $radioLabelPoly = $('<div class="image-btn-wrapper-poly" data-variant-id="' + polyVariantId + '"><div class="image-title">' +
      '<a href="#"><label class="radio-image-label">' +
      '<img src="' + imgUrlPoly + '" height="50" width="50">' + 
      $radioButtonPoly[0].outerHTML +
      '</label></a></div><div class="btn_wrapper"></div></div>');

    // Append radio button to the container
    $('#radioButtonPolyElement').append($radioLabelPoly);
  });

  // Handle changes in radio buttons
$('#radioButtonPolyElement').on('change', 'input[type="radio"]', function() {
  var selectedValuePoly = $(this).val();
  var selectedVariantId = $(this).attr("data-variant-id");
  $(".selectedVariantName").text(selectedValuePoly);
  var polyVariantIdSwatch = getVariantIdFromUrlPoly();
  
  $('#radioButtonPolyElement input[type="radio"]').each(function() {
    var dataVariantId = $(this).attr('data-variant-id');
    if (dataVariantId === selectedValuePoly) {
      // Perform actions when a match is found
      $(this).addClass("matchedRadio");
    } else {
      // Perform actions when no match is found
      $(this).removeClass("matchedRadio");
    }
  });
  
  if(selectedVariantId === polyVariantIdSwatch) {
    $(".image-btn-wrapper-poly").addClass("polySwatchBorder");
  } else {
    $(".image-btn-wrapper-poly").removeClass("polySwatchBorder");
  }
  
  $('.polycolor').val(selectedValuePoly).trigger('change'); // Trigger change event manually
});


  

// Add 'showModal' class when clicking on '.changeSelect' element
$(".variantValue").on("click", function(){
    $(".main-options-drawer").addClass('showModal');
}); 

// Remove 'showModal' class when clicking on '#closeBtn-main-options' element
$(document).on("click", "#closeBtn-main-options", function(){
    $(".main-options-drawer").removeClass('showModal');
});


$(document).on("click", ".stain_custom_options", function() {
  function getVariantIdFromUrl() {
    var url = window.location.href;
    var regex = /variant=([0-9]+)/;
    var match = regex.exec(url);
    if (match && match[1]) { 
        return match[1]; 
    }
    return null;
}
  $(".stain_options select").blur();
 var variantId = getVariantIdFromUrl();
 $(".variant__description_drawer").each(function() {
        var stainOptionId = $(this).attr('data-variant-id');
        
        // Check if the current stainOptionId matches the variantId
        if (stainOptionId === variantId) {
            $(this).addClass('active'); // Add class 'active' to the matched element
        } else {
            $(this).removeClass('active'); // Remove class 'active' from unmatched elements
        }
    });
 
});
  
// Remove 'showModal' class when clicking on '.radio-image-label img' element
$(document).on("click", ".image-title", function(event){
    // Find the closest ancestor element with the class 'main-options-drawer'
    var parentElement = $(this).closest('.main-options-drawer');
    $(".main-options-drawer").removeClass('showModal');
  
    // Find the input element within the clicked .image-title element
    var inputValue = $(this).find('input').val();
  $(".variantValue").html(inputValue);
    // Now you can use inputValue for further processing
   // console.log("Input value:", inputValue);
});



$(".product-form__input select").change(function(){
    // Get the selected value
    var selectedOption = $(this).attr('data-variant-title');
   $('.variant__description_drawer').hide();
    if(selectedOption === 'Wood Species'){
       $('.variant__description_drawer').show();
    }else{
       $('.variant__description_drawer').hide();
    }
    console.log(selectedOption);
});

});



$(document).ready(function(){
    function truncateText(selector, maxLength) {
        var element = $(".search-page-data, .p-desc");
        var text = element.text();

        if (text.length > maxLength) {
            var truncated = text.substr(0, maxLength) + '...';
            element.text(truncated);
        }
    }

    // Apply the function to the element
    truncateText('.truncate', 50); // Adjust the selector and maxLength as needed



    // Select all elements with the class 'estimated-data-section'
    var $elements = $('.estimated-data-section');

    // Check if there is more than one element
    if ($elements.length > 1) {
        // Remove all elements except the first one
        $elements.slice(1).remove();
    }


});

/* estimate section javascript */

$(document).ready(function () {
    setTimeout(function () {
      const closestElement = $('#downpay-block').closest('.shopify-app-block');
        if (closestElement.length && $('.estimated-data-to-move').length) {
            $('.customize-section').appendTo(closestElement);
            $('.estimated-data-to-move').appendTo(closestElement);
            console.log("Element moved successfully.");
        } else {
            console.error("Either #downpay-block or #estimated-data-section is missing.");
        }
    }, 1000); // 1000ms = 1 second delay
});


document.addEventListener("DOMContentLoaded", function () {
    function updateThumbnailSelection() {
        let selectedSwatch = document.querySelector('.product-form__input input[type="radio"]:checked');
        let thumbnails = document.querySelectorAll('.thumbnail-list [data-media-alt]');

        if (selectedSwatch) {
            let selectedValue = selectedSwatch.value.trim();

            thumbnails.forEach(thumb => {
                let altText = thumb.getAttribute('data-media-alt').trim();

                if (altText === selectedValue) {
                    thumb.setAttribute('aria-current', 'true');
                    thumb.click(); // Trigger click on the matching thumbnail
                } else {
                    thumb.removeAttribute('aria-current');
                }
            });
        }
    }

    // Run on page load
    updateThumbnailSelection();

    // Listen for swatch changes
    document.querySelectorAll('.product-form__input input[type="radio"]').forEach(input => {
        input.addEventListener('change', updateThumbnailSelection);
    });
});
